import { render, staticRenderFns } from "./BarList.vue?vue&type=template&id=7c711924&scoped=true"
import script from "./BarList.vue?vue&type=script&lang=js"
export * from "./BarList.vue?vue&type=script&lang=js"
import style0 from "./BarList.vue?vue&type=style&index=0&id=7c711924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c711924",
  null
  
)

export default component.exports